import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto, UpdateTransferRecordDto } from '../types';

export const useUpdateTransferRecord = (transferId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, { recordId: string } & UpdateTransferRecordDto>({
    mutationFn: ({ recordId, ...data }) =>
      apiClient.patch(
        `/v1/projects/${projectId}/transfers/${transferId}/records/${recordId}`,
        data,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
      queryClient.invalidateQueries({ queryKey: ['transfer', transferId] });
    },
  });
};
